<template>
<div id="content-wrapper">
  <div id="item-wrapper">
      <h3>Willkommen bei der Schreinerei Schill</h3>
      <div id="items">
        <router-link v-for="item in items" :key="item.name" tag="div" :to="item.link" class="control" exact>
            <smart-icon :icon="item.icon"></smart-icon>
            <div>{{item.title}}</div>
        </router-link>
  </div>
  </div>
    <div id="footer">
      <div class="grid h-min-fill">
        <div>Tel:</div>
        <div><a href="tel:+49761402323">0761 / 402323</a></div>
        <div>Fax:</div>
        <div><a href="fax:+49761402907">0761 / 402907</a></div>
        <div>Mail:</div>
        <div><a href="mailto:schreinerei-schill@t-online.de">schreinerei-schill@t-online.de</a></div>
      </div>
      <div class="grid">
        <div>Hexentalstraße 14a</div>
        <div>79249 Merzhausen</div>
        <div>Geschäftszeiten Mo - Fr 07:00 - 17:15<br>und jederzeit nach telefonischer Vereinbarung</div>
      </div>
  </div>
</div>
</template>

<script>
import pages from '@/pages.js'

export default {
  name: 'Home',
  data(){
    return {
      items: pages
    }
  }  
}
</script>

<style>
#content-wrapper{
    display:grid;
    grid-template-rows: 1fr min-content;
    height:100%;
    background: url('../assets/media/background.jpg') no-repeat;
    background-size: cover;
}

#item-wrapper{
    display: grid;
    grid-template-rows: min-content 1fr;
    grid-row-gap: 16px;
    align-self: center;
    
    background: rgba(255, 255, 255, 0.6);
    margin: 0 20%;
    padding: 32px;
}

#item-wrapper > h3{
    justify-self: center;
    font-family: "OrkneyBold";
    font-size: 2em;

    margin: 0;
}
  #items{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    grid-gap: 32px;

  }

  #items > div{
      display: grid;
      grid-template-rows: 60px 40px;
      grid-row-gap: 8px;

      padding: 8px;
      align-items: center;
      justify-items: center;
      white-space: pre-line;
      text-align:center;

      border: 1px dotted rgb(0,0,0,.4);
    box-shadow: 4px 4px 8px rgba(0,0,0, .4);
  }

  #items svg.icon{
    padding: 0;
  }

  #footer{
      display:grid;
      grid-template-columns: auto auto;
      grid-auto-flow: column;
      grid-column-gap: 16px;

      padding:16px;

      justify-self: center;
  }

  #footer a, #footer a:visited{
    color: inherit;
    text-decoration: inherit;
  }
</style>
